/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.Distributors {
    "use strict";

    export class DistributorsContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            rootScope: ng.IRootScopeService
            ) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);

            this.baseEndpoint = appSettings.API_ENDPOINTS.distributor;
            this.sectionTemplatePath = "app/plugins/distributors/sectionViews/";
            

            this.buildCrudSecurityKeys(this.securityKeys.DATA_DISTRIBUTOR_TAB_MAIN);
            this.entityType = 'Distributor';
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_DISTRIBUTOR_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0, "SECTION_DISTRIBUTOR_MAIN", "main.html", true, false, this.appSettings.API_ENDPOINTS.distributor, "", this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.Distributor, null, this.securityKeys.DATA_DISTRIBUTOR_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

                this.sections.push(new NotesSection(0, "SECTION_DISTRIBUTOR_NOTES", "notes.html", true, false, this.appSettings.API_ENDPOINTS.distributor, "", this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.Distributor, null, this.securityKeys.DATA_DISTRIBUTOR_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
        }


        initializeHeader(model:any): void {
                this.headerContent = model.displayName; 
                this.businessTypeDetail = model.businessTypeDetail;
        }

        postCopy(): void {
            super.postCopy();
            let model = this.castModel<Model.Distributor>();
            model.displayName = undefined;
            model.contactName = undefined;
            model.contactPhone = undefined;
            model.emailAddress = undefined;
            model.accountNumber = undefined;
            model.address = undefined;
        }
    }
}